import { render, staticRenderFns } from "./FavoritesCount.vue?vue&type=template&id=4d276338&"
import script from "./FavoritesCount.vue?vue&type=script&lang=ts&"
export * from "./FavoritesCount.vue?vue&type=script&lang=ts&"
import style0 from "./FavoritesCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports